module.exports = __webpack_public_path__ + "img/me.4a571a22.png";